import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const NevadaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg id='nevada' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' className='map'>
			<polygon
				id='NV_ZS'
				points='760.53 448.19 768.66 724.82 770.2 753.05 773.64 790.39 770.96 819.51 763.39 835.74 752.87 837.94 730.75 825.02 715.68 828.18 706.85 845.4 723.77 926.04 718.55 953.49 231.93 490.45 233.16 438.22 760.53 448.19'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NV_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NV_ZS')}
			/>
			<polygon
				id='NV_ZN'
				points='760.53 448.19 751.48 140.57 497.76 145.5 240.16 142.45 233.16 438.22 760.53 448.19'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NV_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NV_ZN')}
			/>
			<polygon
				points='259.71 468.37 259.82 472.7 264.36 472.7 259.88 475.37 259.99 479.69 257.11 477.02 252.63 479.69 255.34 475.37 252.46 472.7 257.01 472.7 259.71 468.37'
				className='shape'
			/>
			<rect x='264.31' y='474.63' width='138.07' height='20' fill='none' className='shape' />
			<path
				d='M276.24,491.15c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M288.24,491.67c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM289.53,481.55c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M295.54,491.67l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M305.7,489.65c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M328.11,484.62c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM319.19,487.09c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M331.93,491.67l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M365.21,491.15c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M369.68,491.67l2.22-11.61h1.99l-2.22,11.61h-1.99ZM372.26,476.82c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M382.79,476.94l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M390.33,480.06l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='688.76 813.36 688.87 817.68 693.42 817.68 688.94 820.35 689.04 824.67 686.17 822 681.69 824.67 684.39 820.35 681.52 817.68 686.06 817.68 688.76 813.36'
				className='shape'
			/>
			<rect x='574.77' y='790.34' width='118.6' height='20' fill='none' className='shape' />
			<path
				d='M578.59,791.2h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M596.11,807.38c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM597.4,797.26c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M603.51,805.36c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M624.9,807.38l-2-16.18h2.03l1.18,10.36c.18,1.67.29,2.59.31,3.66h.07c.41-1,.9-2.21,1.77-3.91l5.15-10.11h2.19l-8.51,16.18h-2.2Z'
				className='shape'
			/>
			<path
				d='M644.59,806.71c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM642.39,797.05c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M649.61,810.02c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM658.53,797.5c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M672.16,807.38c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM673.45,797.26c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M679.56,805.36c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<polygon
				points='265.63 406.91 265.74 411.24 270.29 411.24 265.81 413.91 265.91 418.23 263.04 415.56 258.56 418.23 261.26 413.91 258.39 411.24 262.93 411.24 265.63 406.91'
				className='shape'
			/>
			<rect x='270.24' y='413.17' width='59.09' height='20' fill='none' className='shape' />
			<path
				d='M274.02,414.27c.99-.22,2.33-.35,3.53-.35,1.62,0,3,.38,3.86,1.17.75.65,1.19,1.58,1.19,2.68,0,2.35-1.8,4.1-3.84,4.67v.06c1.13.38,1.66,1.59,1.78,3.25.18,2.25.29,3.8.5,4.45h-2.06c-.09-.34-.26-2.04-.37-3.9-.13-2.23-.94-3.15-2.55-3.15h-1.77l-1.34,7.05h-1.97l3.03-15.94ZM274.6,421.62h1.78c2.52,0,4.15-1.65,4.15-3.59,0-1.73-1.3-2.51-3.13-2.51-.79,0-1.3.07-1.68.17l-1.13,5.92Z'
				className='shape'
			/>
			<path
				d='M294.22,429.54c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM292.02,419.89c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M299.14,430.21l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M325.52,423.17c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM316.59,425.63c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='564.4 242.72 564.5 247.05 569.05 247.05 564.57 249.72 564.68 254.04 561.8 251.37 557.32 254.04 560.02 249.72 557.15 247.05 561.69 247.05 564.4 242.72'
				className='shape'
			/>
			<rect x='569' y='248.98' width='50.7' height='20' fill='none' className='shape' />
			<path
				d='M579.06,258.42h-5.88l-1.12,5.9h6.62l-.33,1.7h-8.61l3.08-16.18h8.24l-.33,1.7h-6.24l-.99,5.18h5.89l-.33,1.69Z'
				className='shape'
			/>
			<path d='M583.36,266.02l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M591.28,266.02l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.76,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M615.45,258.98c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM606.52,261.44c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<rect x='575.52' y='605' width='60.55' height='43.33' fill='none' className='shape' />
			<path
				d='M574.9,644.53l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M609.39,641.35c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='361.74'
				y='266.02'
				width='72.08'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M361.12,305.54l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M394.98,308.62l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
		</svg>
	);
};

NevadaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default NevadaMap;
